<template>
  <div class="contact">
    <div class="container">
      <div class="organ">
        <el-link icon="el-icon-phone" :underline="false" style="margin-bottom: 30px;">联系我们</el-link>
        <!-- <p>Contact us</p> -->
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content bg-purple">
              <div class="contact-head">高质量、快速度、低成本、客户满意</div>
              <div class="contact-idea">河北国超信息科技有限公司始终坚持“赋予信息以高质量”这一企业理念，始终贯彻“高质量、快速度、低成本、客户满意”这一经营方针和“诚实、努力、虚心”这一用人原则，始终站在客户的立场以崭新的创意和灵活的构思为客户提供专业优质的服务。创造性的提升客户的商品品牌和价值，我们愿成为众多企业喜忧与共、并肩战斗的伙伴。</div>
              <div class="contact-message">
                <div class="contact-title"><span>电 话: </span><span>(0311)83308230/87375060/15830696619</span></div>
                <div class="contact-title"><span>传 真: </span><span>(0311)87375066</span></div>
                <div class="contact-title"><span>邮 箱: </span><span>caoyanshuang@hbguochao.com</span></div>
                <div class="contact-title"><span>地 址: </span><span>河北省辛集市龙泉街西段9号</span></div>
              </div>
              <div class="more-about">
                <el-button type="primary" @click="toContarct()">更多联系方式</el-button>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="content">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-input placeholder="您的姓名或公司名称" v-model="name" id="name" clearable>
                  </el-input>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-input placeholder="您的邮箱地址" v-model="email" id="email" clearable>
                  </el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-input placeholder="您的主要意向" v-model="content" id="content" clearable>
                  </el-input>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-input placeholder="您的联系电话" v-model="phone" id="phone" clearable>
                  </el-input>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input type="textarea" :rows="2" placeholder="您的其它信息" v-model="other" id="other" clearable>
                  </el-input>
                </el-col>
              </el-row>
              <div class="more-about">
                <el-button type="primary" id="submit" @click="sendContact()" :loading="loading">{{send}}</el-button>
              </div>
            </div>

          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        name: '',
        email: '',
        content: '',
        phone: '',
        other: '',
        loading: false,
        send: '提交留言'
      }
    },
    methods: {
      toContarct: function() {
        this.$router.push({
          path: '/contact',
        })
      },
      sendContact: function() {
        var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (this.email != '' && !regEmail.test(this.email)) {
          this.$alert('邮箱格式不正确');
          return
        }
        if (this.name == "") {
          this.$alert('请填写您的姓名或公司名称');
          return
        }
        if (this.phone != "" && !(/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,4}))?$/.test(this.phone)) && !(/^1[34578]\d{9}$/.test(
            this.phone))) {
          this.$alert('请正确填写您的联系电话');
          return;
        }
        if (this.phone == "") {
          this.$alert('请填写您的联系电话');
          return
        }
        this.loading = true;
        this.send = "正在提交";
        let _this = this;
        this.axios.get(this.$http + "api/index/setContent", {
            params: {
              name: this.name,
              email: this.email,
              content: this.content,
              phone: this.phone,
              other: this.other
            }
          })
          .then((res) => {
            console.log(res);
            setTimeout(function() {
              _this.loading = false
              _this.send = "提交成功"
              _this.name = ""
              _this.email = ""
              _this.content = ""
              _this.phone = ""
              _this.other = ""
            }, 1000)
            setTimeout(function() {
              _this.send = "提交留言"
            }, 2000)
          })
          .catch((err) => {})
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue